import { useEffect, useState } from "react";
import useAxios from "../../../../../../hooks/useAxios";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../../shared/components/card/Card";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { Separator } from "../../../../../../shared/components/separator/Separator";
import { DATA_EXPLORERS_ACTIONS_PERFORMANCE_METRICS_DIMENSIONS_SELECTABLES } from "../../../../../../shared/lib/apiEndpointsResolver";
import { catchFunction } from "../../../../../../shared/lib/utils";
import ActionsPerformanceDataExplorerFieldsQuery from "./ActionsPerformanceDataExplorerFieldsQuery";
import ActionsPerformanceDataExplorerFieldsPanel from "./ActionsPerformanceDataExplorerFieldsPanel";
import { useTranslation } from "react-i18next";

const ActionsPerformanceDataExplorerFilter = ({
  onMetricsChangeValue,
  onDimensionsChangeValue,
}) => {
  const axios = useAxios();
  const [fields, setFields] = useState([]);
  const { t } = useTranslation();

  const fetchFieldFilterSelectables = () => {
    axios
      .get(DATA_EXPLORERS_ACTIONS_PERFORMANCE_METRICS_DIMENSIONS_SELECTABLES)
      .then((response) => {
        const data = response.data;
        setFields([
          ...data.metrics.map(fieldMapFn("metric")),
          ...data.dimensions.map(fieldMapFn("dimension")),
        ]);
      })
      .catch(catchFunction);
  };

  const fieldMapFn = (type) => {
    return (field) => ({
      type,
      label: field.label,
      value: field.value,
      toggle: false,
    });
  };

  const handleUpdateFieldFilter = (value, type, isAddition) => {
    // toggle field to show that is selected
    toggleFieldFilter(value, isAddition);

    // set selected field on filter
    if (type === "metric") {
      onMetricsChangeValue(value, isAddition);
    } else {
      onDimensionsChangeValue(value, isAddition);
    }
  };

  // delete or add field filter depending on its current toggle state
  // (if it is enabled -> disabled it, and viceversa)
  const handleChangeFieldFilter = ({ value, type, toggle }) => {
    handleUpdateFieldFilter(value, type, !toggle);
  };

  const handleRemoveFieldFilter = ({ value, type }) => {
    handleUpdateFieldFilter(value, type, false);
  };

  const toggleFieldFilter = (value, toggle) => {
    const fieldIndex = fields.findIndex((f) => f.value === value);

    setFields(
      fields.map((field, idx) => {
        if (idx === fieldIndex) {
          return {
            ...field,
            toggle,
          };
        } else {
          return field;
        }
      }),
    );
  };

  useEffect(() => {
    fetchFieldFilterSelectables();
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t("dataExplorers.actionsPerformance.metricsAndDimensions.title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ActionsPerformanceDataExplorerFieldsQuery
          fields={fields}
          onRemoveField={handleRemoveFieldFilter}
        />
        {fields.filter((f) => f.toggle).length === 0 && (
          <MagnifyingGlassIcon className="w-6 h-6 mb-1" color="#d0d0d0" />
        )}
        <Separator className="my-2" />
        <ActionsPerformanceDataExplorerFieldsPanel
          fields={fields}
          onUpdateFieldFilter={handleChangeFieldFilter}
        />
      </CardContent>
    </Card>
  );
};

export default ActionsPerformanceDataExplorerFilter;
